import { PosEnumMultiSelectProps } from 'src/core/POS/PosMultiSelect/PosEnumMultiSelect';
import { PosEnumSelectProps } from 'src/core/POS/PosSelect';
import { useUserHasAnyOfPermissions } from 'src/hooks/useUserHasAnyOfPermissions';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { DELIVERY_OPTIONS_TO_CID } from 'src/utils/constants/contentIdMaps';
import { DeliveryType, Feature, Permission } from 'src/WebApiController';

type DeliveryTypeAdditionalOptions = {
  valueOptionsContent?: Record<DeliveryType, string>;
  // Use this when the delivery type is used for read only purposes (filter, etc)
  allowCustomDeliveryType?: boolean;
};

export type DeliveryTypeSelectorProps = Omit<
  PosEnumSelectProps<DeliveryType>,
  'valueOptionsContent' | 'valueOptionsIcon'
> &
  DeliveryTypeAdditionalOptions;

export type DeliveryTypeMultiSelectorProps = Omit<
  PosEnumMultiSelectProps<DeliveryType>,
  'valueOptionsContent' | 'valueOptionsIcon'
> &
  DeliveryTypeAdditionalOptions;

type UseDeliveryTypeSelectorProps = Pick<
  DeliveryTypeSelectorProps,
  'allowCustomDeliveryType' | 'valueOptionsContent'
>;

export const useDeliveryTypeSelector = ({
  allowCustomDeliveryType,
  valueOptionsContent,
}: UseDeliveryTypeSelectorProps) => {
  const hasCustomDeliveryTypeFeature = useUserHasFeature(
    Feature.CustomDeliveryType
  );

  const canSetCustomDeliveryType = useUserHasAnyOfPermissions(
    Permission.Purchases_UpdateCustomDeliveryType,
    Permission.Purchases_UpdateCustomDeliveryTypeOwned
  );

  const moderatedOptionsContent = Object.entries(
    valueOptionsContent ?? DELIVERY_OPTIONS_TO_CID
  ).reduce(
    (acc, [key, val]) => {
      if (
        key === DeliveryType.Custom &&
        ((!allowCustomDeliveryType && !canSetCustomDeliveryType) ||
          !hasCustomDeliveryTypeFeature)
      ) {
        return acc;
      }

      if (key === DeliveryType.Wallet) {
        return acc;
      }

      return { ...acc, [key]: val };
    },
    {} as Record<DeliveryType, string>
  );

  return {
    moderatedOptionsContent,
  };
};
